/** Support chat on every page. Answers come from the site's own policies. */
export default {
  open: "Support",
  close: "Close support chat",
  title: "Support",
  subtitle: "Common questions are answered here. A person replies to messages within one business day.",
  greeting:
    "Hello. I can help with plans, payments, points and refunds. If you need a person, leave a message and we reply within one business day.",
  placeholder: "Ask a question…",
  send: "Send",
  leaveMessage: "Leave a message",
  topics: {
    hours: "Support hours",
    refund: "Refunds",
    payment: "Payments",
    human: "Talk to a person",
  },
  answers: {
    hours:
      "Customer service answers messages Monday–Friday, 09:00–18:00 (Bulgarian time). We reply within one business day.",
    refund:
      "The first Starter, Pro or Elite payment has a 30-day money-back guarantee: a full refund if you have not used the points, or the unused points if you have. A Custom plan follows the same rule for 14 days. Email support@aistylemedia.com with the email you used and your order number. The number is in your confirmation email and in your order history.",
    payment:
      "Each plan is a one-time payment for a pack of points. Nothing renews automatically. You pay by card on the secure page of DSK Bank or PostBank. Prices are in euros and include all taxes.",
    points:
      "An image costs 1 point and a video clip costs 2. A new account gets 10 free points once. Paid points are added after the bank confirms the payment. If they are still missing after 30 minutes, leave a message with your order number.",
    pricing:
      "Starter, Pro and Elite are one-time packs of points. You can also choose your own amount from €10 on the pricing page. You are only charged when you place an order.",
    account:
      "Use Sign in to open your profile. If you paid without an account, create one with the same email address you used at checkout and the points are there.",
    contact:
      "Email support@aistylemedia.com or Info@aistylemedia.com, or leave a message in this chat. We reply within one business day, Monday–Friday, 09:00–18:00 (Bulgarian time).",
    human:
      "Leave your name, email and question below. It goes to customer service, and a person replies within one business day.",
  },
  fallback:
    "I don't have an answer for that. Leave a message, or email support@aistylemedia.com, and a person will reply within one business day.",
  form: {
    name: "Name",
    email: "Email",
    message: "Message",
    messageHint: "Up to 500 characters.",
    send: "Send to support",
    sending: "Sending…",
    nameRequired: "Please enter your name.",
    emailRequired: "Please enter a valid email address.",
    messageRequired: "Please enter a message.",
    success: "Message sent. We'll reply to that email within one business day.",
    subject: "Support chat",
  },
};
